import React, { useState, useEffect } from "react";
import Slider from "react-slick";

export default function EcoSystem() {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
    const [activeId, setActiveId] = useState(0);
  let slider1, slider2;

  // Static ecosystem content
  const ecoContents = [
    {
      title: "Quantum and Fusion – Benchmark Multiplayer Engines",
      description:
        "Fusion's features, performance and achievable player count on multiple network topologies are unmatched for state-sync engines. Quantum is a deterministic predict/rollback game engine that leads with zero lag and no netcode."
    },
    {
      title: "Voice and Chat – Flexible and Secure Communications",
      description:
        "Secure voice and text chat for games, virtual worlds or other online communities. Voice and Chat provide low-latency comms with features such as 3D audio, noise reduction, echo cancellation, smart messages and more."
    },
    {
      title: "Run Cross-Platform Networking Engines with Low Latency",
      description:
        "Realtime is the low-level API for multiplayer, matchmaking, NAT punch-through, rooms management, custom properties, encryption and a lot more. Realtime is the foundation for our higher-level network engines Quantum and Fusion."
    },
    {
      title: "Scalable, Reliable and Always Connects",
      description:
        "Photon apps run in our low-latency Cloud where our operations team monitors servers 24/7. Photon Cloud scales to any number of players and can be upgraded with SLAs, enhanced DDOS protection and plugins for custom server logic."
    },
    {
      title: "Full World-Wide Coverage for Realtime Multiplayer",
      description:
        "Photon is hosted in all major regions to support world-wide low latency connections in ALL countries. Flexible connection settings allow player agglomeration to find the quickest match."
    }
  ];

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  }, [slider1, slider2]);

  return (
    <section className="released-games-area gray-bg pt-40 pb-40">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-10">
            <div className="section-title title-style-three text-center mb-20">
              <h2>
                Moitribe <span>Ecosystem</span>
              </h2>
              <p>
                Products let you build and launch multiplayer games worldwide across all platforms.
                You can focus on developing your game while we scale to meet the needs of your players –
                from the first users to millions.
              </p>
            </div>
          </div>
        </div>

        <div className="row align-items-center">
          {/* Main slider */}
          <div className="col-xl-8 col-lg-12">
            <Slider
              className="released-game-active"
              asNavFor={nav2}
              ref={(slider) => (slider1 = slider)}
              arrows={false}
              autoplay={true}
               afterChange={(index) => setActiveId(index)}
               
               >
              {ecoContents.map((item, i) => (
                <div key={i} className="released-game-carousel"
                
                 >
                  <div className="released-game-item">
                    <div className="released-game-item-bg" />
                    <div className="released-game-content">
                      <h4>{item.title}</h4>
                      <p>{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <div style={{cursor:"pointer"}} className="col-xl-4 col-lg-12">
            <Slider
              className="released-game-nav"
              asNavFor={nav1}
              swipeToSlide={true}
              focusOnSelect={true}
              ref={(slider) => (slider2 = slider)}
              slidesToShow={3}
              vertical={true}
              arrows={false}
              autoplay={true}
            >
              {ecoContents.map((item, i) => (
                <div style={{cursor:"pointer"}} key={i} 
                 onClick={() => setActiveId(i)}
                 className={`released-game-nav-item p-4 text-black bg-white ${
    activeId === i ? "bg-danger-dark" : "dark"
  }`}>
                  <h5 className="text-black" >{item.title}</h5>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
}
